(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["p7-drop-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__p7DropCar) return;
    root.__p7DropCar = true;
    var rail = root.querySelector('[data-p7dcar-rail]');
    if (!rail) return;

    var prev = root.querySelector('[data-p7dcar-prev]');
    var next = root.querySelector('[data-p7dcar-next]');
    function stride() {
      var cell = rail.querySelector('.p7-drop-car__cell');
      return cell ? cell.getBoundingClientRect().width + 10 : rail.clientWidth * 0.8;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -stride(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: stride(), behavior: 'smooth' }); });

    /* Scroll indicator. Position is read from the rail rather than tracked,
       so arrows, a finger, a trackpad and a keyboard all drive it for free.
       Stays hidden unless the rail actually overflows: a size filter can cut
       the rail down to two cards, and a bar that fills its track and cannot
       move reads as broken. Re-synced from update() for that reason. */
    var prog = root.querySelector('[data-p7dcar-progress]');
    var progBar = root.querySelector('[data-p7dcar-progress-bar]');
    var progQueued = false;

    function syncProgress() {
      progQueued = false;
      if (!prog || !progBar) return;
      var max = rail.scrollWidth - rail.clientWidth;
      if (max <= 1) { prog.hidden = true; return; }
      prog.hidden = false;
      var frac = rail.clientWidth / rail.scrollWidth;
      var pos = Math.min(Math.max(rail.scrollLeft / max, 0), 1);
      progBar.style.width = (frac * 100) + '%';
      progBar.style.left = (pos * (100 - frac * 100)) + '%';
    }
    function progressTick() {
      if (progQueued) return;
      progQueued = true;
      window.requestAnimationFrame(syncProgress);
    }

    rail.addEventListener('scroll', progressTick, { passive: true });
    window.addEventListener('resize', progressTick);

    /* "Always best selling" (data-p7dcar-best, set by Liquid only when the
       page is in some other order). Re-render this one section via the
       Section Rendering API and swap the cells in. p7-card-filter.js's
       late-card observer re-applies the size filter to the new cards. On
       any failure the server-rendered rail simply stays. */
    var bestUrl = root.getAttribute('data-p7dcar-best');
    if (bestUrl && window.fetch) {
      fetch(bestUrl, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-p7dcar-rail]');
          if (!fresh || !fresh.children.length) return;
          while (rail.firstChild) rail.removeChild(rail.firstChild);
          while (fresh.firstChild) rail.appendChild(fresh.firstChild);
          /* The drawer p7-quickview.js bound at load holds the OLD panel
             order, so a trigger on a re-ordered card would open the wrong
             product. Strip them: the cards fall back to plain PDP links. */
          Array.prototype.forEach.call(rail.querySelectorAll('[data-qv-trigger]'), function (a) {
            a.removeAttribute('data-qv-trigger');
          });
          rail.scrollLeft = 0;
          progressTick();
          queued();
        })
        .catch(function () {});
    }
    /* Card images are lazy, so scrollWidth is not final at DOMContentLoaded. */
    window.addEventListener('load', progressTick);
    progressTick();

    var note = root.querySelector('[data-p7dcar-note]');
    var noteText = root.querySelector('[data-p7dcar-note-text]');
    var empty = root.querySelector('[data-p7dcar-empty]');
    var emptyText = root.querySelector('[data-p7dcar-empty-text]');

    function update() {
      var P = window.P7SizePrefs;
      if (!P || !note || !empty) return;
      /* Annotate-only rail (home): no cell ever hides, so "Showing size N"
         and the empty state would both lie. Keep them silent. */
      if (rail.hasAttribute('data-p7-cards-annotate-only')) {
        note.hidden = true;
        empty.hidden = true;
        progressTick();
        return;
      }
      var prefs = P.read();
      var size = (prefs && prefs.s && prefs.s[0]) || '';
      var visible = 0;
      var cells = rail.children;
      for (var i = 0; i < cells.length; i++) {
        var card = cells[i].querySelector('[data-card]');
        if (!cells[i].hidden && !(card && card.hidden)) visible++;
      }
      if (size) {
        /* Built as nodes, not innerHTML: `size` comes out of stored prefs and
           is echoed straight back into the page. textContent keeps it inert. */
        /* Box and Clear only, stacked and right-aligned (owner 2026-09-05);
           "Showing size" stays for screen readers. */
        noteText.textContent = '';
        var sr = document.createElement('span');
        sr.className = 'p7-drop-car__sr';
        sr.textContent = 'Showing size ';
        noteText.appendChild(sr);
        var box = document.createElement('span');
        box.className = 'p7-drop-car__note-size';
        box.textContent = size;
        noteText.appendChild(box);
        note.hidden = false;
      } else {
        noteText.textContent = '';
        note.hidden = true;
      }
      if (size && visible === 0) {
        emptyText.textContent = 'Nothing in the drop in size ' + size;
        empty.hidden = false;
      } else {
        empty.hidden = true;
      }
      /* Filtering hides cells, so the rail's scrollWidth has just changed. */
      progressTick();
    }
    /* p7-card-filter.js applies hiding on the same events; the timeout
       lets it finish before this recount reads the DOM. */
    function queued() { window.setTimeout(update, 60); }
    document.addEventListener('p7:size-prefs-change', queued);
    document.addEventListener('p7:size-prefs-ready', queued, { once: true });
    root.addEventListener('click', function (e) {
      var clear = e.target.closest('[data-p7dcar-clear]');
      if (!clear) return;
      var P = window.P7SizePrefs;
      if (!P) return;
      var prefs = P.read();
      P.set({ s: [], a: (prefs && prefs.a) || [] });
    });
    queued();
  }
  function boot() {
    var roots = document.querySelectorAll('[data-p7-drop-car]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p7-story-cards"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__p7Scx) return;
    root.__p7Scx = true;

    var track = root.querySelector('[data-scx-track]');
    if (!track) return;
    var slides = track.children;
    if (!slides.length) return;

    var nav = root.querySelector('[data-scx-nav]');
    var prev = root.querySelector('[data-scx-prev]');
    var next = root.querySelector('[data-scx-next]');
    var count = root.querySelector('[data-scx-count]');
    var slider = root.querySelector('[data-scx-slider]');
    var sliderBar = root.querySelector('[data-scx-slider-bar]');
    var ticks = root.querySelectorAll('[data-scx-ticks] .p7-scx__tick');
    var bgLayers = root.querySelectorAll('[data-scx-bg-layer]');

    if (nav) nav.hidden = false;
    if (prev) prev.hidden = false;
    if (next) next.hidden = false;
    if (slider) slider.hidden = false;

    /* Stride is MEASURED, never computed from a declared width: the card is
       sized from a height token and clamped against the viewport, so any
       arithmetic here would drift out of step with the CSS. */
    function stride() {
      if (slides.length > 1) {
        var d = slides[1].offsetLeft - slides[0].offsetLeft;
        if (d > 0) return d;
      }
      return slides[0].getBoundingClientRect().width + 24;
    }

    function current() {
      var s = stride();
      if (!s) return 0;
      var i = Math.round(track.scrollLeft / s);
      return Math.min(Math.max(i, 0), slides.length - 1);
    }

    var bgTop = 0;
    var bgShown = null;
    function paintBackdrop(i) {
      if (bgLayers.length < 2 || bgShown === i) return;
      bgShown = i;
      var cell = slides[i];
      var src = cell.getAttribute('data-scx-bg-src') || '';
      var ground = cell.getAttribute('data-scx-ground') || 'photo';
      var incoming = bgLayers[1 - bgTop];
      var outgoing = bgLayers[bgTop];
      if (src) {
        incoming.style.backgroundImage = 'url("' + src + '")';
        incoming.style.backgroundColor = '';
      } else {
        /* A flat slide has no photograph, so the backdrop takes its ground
           colour rather than keeping the previous slide's image, which would
           read as the wrong card being behind it. */
        incoming.style.backgroundImage = 'none';
        incoming.style.backgroundColor = ground === 'light' ? '#f4f4f2' : '#0b0b0b';
      }
      incoming.style.opacity = '1';
      outgoing.style.opacity = '0';
      bgTop = 1 - bgTop;
    }

    var queued = false;
    function sync() {
      queued = false;
      var i = current();

      if (count) {
        count.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + slides.length).slice(-2);
      }
      for (var t = 0; t < ticks.length; t++) {
        ticks[t].classList.toggle('is-active', t === i);
      }
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;

      if (sliderBar) {
        var max = track.scrollWidth - track.clientWidth;
        if (max > 1) {
          var frac = 1 / slides.length;
          var pos = Math.min(Math.max(track.scrollLeft / max, 0), 1);
          sliderBar.style.width = (frac * 100) + '%';
          sliderBar.style.left = (pos * (100 - frac * 100)) + '%';
        } else {
          sliderBar.style.width = '100%';
          sliderBar.style.left = '0%';
        }
      }

      paintBackdrop(i);
    }
    function tick() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(sync);
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -stride(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: stride(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    window.addEventListener('load', tick);
    tick();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-p7-scx]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* Theme editor re-renders a section into a fresh node, so re-run boot. */
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p7-team-carousel"] && !Shopify.designMode) return;
  try {
    
  /* ------------------------------------------------------------------
     P7 · Team carousel controller.

     Scroll position is the ONLY source of truth. goTo writes scrollLeft
     and nothing else; the scroll handler derives the index back out and
     repaints the counter, the ticks, the hints and which card is lit. No
     card content is ever swapped, so nothing can fall out of sync with
     the finger. That is why this build drops the roster's panel mechanic.

     LOOPING is done by cloning the whole card set before and after the
     real one and parking the scroll position in the middle copy. Drift
     into an outer copy is rewound by exactly one set width once scrolling
     has settled. The rewind is invisible because the copies are identical
     and the position is already snapped, and it is deliberately NOT done
     mid-gesture: repositioning during iOS momentum scrolling is what makes
     looping carousels stutter.
     ------------------------------------------------------------------ */
  (function () {
    'use strict';

    function pad2(n) { return (n < 10 ? '0' : '') + n; }

    function init(root) {
      if (!root || root.__p7TcxBound) return;
      root.__p7TcxBound = true;

      var track = root.querySelector('[data-tcx-track]');
      var inner = root.querySelector('[data-tcx-inner]');
      var real = Array.prototype.slice.call(root.querySelectorAll('[data-tcx-slide]'));
      if (!track || real.length === 0) return;

      var bar = root.querySelector('[data-tcx-bar]');
      var counter = root.querySelector('[data-tcx-counter]');
      var ticks = Array.prototype.slice.call(root.querySelectorAll('[data-tcx-tick]'));
      var prevBtn = root.querySelector('[data-tcx-prev]');
      var nextBtn = root.querySelector('[data-tcx-next]');

      var n = real.length;

      /* Never loop inside the theme editor. Cloned cards would carry a second
         copy of every shopify_attributes target and block selection would jump
         to the wrong card. */
      var designMode = !!(window.Shopify && window.Shopify.designMode);
      var looping = root.getAttribute('data-loop') === 'true' && n >= 3 && !designMode && !!inner;

      var slides = real;

      if (looping) {
        var lead = document.createDocumentFragment();
        var tail = document.createDocumentFragment();
        for (var c = 0; c < n; c++) {
          lead.appendChild(makeClone(real[c]));
          tail.appendChild(makeClone(real[c]));
        }
        inner.insertBefore(lead, inner.firstChild);
        inner.appendChild(tail);
        slides = Array.prototype.slice.call(inner.querySelectorAll('[data-tcx-slide]'));
      }

      function makeClone(node) {
        var el = node.cloneNode(true);
        el.setAttribute('data-tcx-clone', '');
        el.classList.remove('is-active');
        /* aria-hidden on a subtree containing focusable elements is invalid
           unless they are also taken out of the tab order. The clone is a
           visual duplicate: reachable by mouse, invisible to AT and to Tab. */
        el.setAttribute('aria-hidden', 'true');
        el.removeAttribute('id');
        Array.prototype.forEach.call(el.querySelectorAll('[id]'), function (x) { x.removeAttribute('id'); });
        Array.prototype.forEach.call(el.querySelectorAll('a, button, [tabindex]'), function (x) { x.tabIndex = -1; });
        Array.prototype.forEach.call(el.querySelectorAll('[data-shopify-editor-block]'), function (x) {
          x.removeAttribute('data-shopify-editor-block');
        });
        el.removeAttribute('data-shopify-editor-block');
        return el;
      }

      var stride = 0;
      var index = 0;

      /* Measured, never computed. The rendered advance includes the margin
         and any border, so a declared width is the wrong number. Every card
         shares the track as offsetParent, so the delta is exact and survives
         a CSS change. */
      function measureStride() {
        if (slides.length < 2) return track.clientWidth;
        return slides[1].offsetLeft - slides[0].offsetLeft;
      }

      function setWidth() { return n * stride; }
      function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
      function logicalOf(i) { return ((i % n) + n) % n; }

      /* An instant, non-animated move. CSS owns scroll-behavior: smooth, so a
         plain assignment would ANIMATE, and animating the loop rewind is
         exactly what would make it visible.

         THE BLINK. Moving the scroll position silently is only half of it.
         The rewind also moves .is-active from a card to its identical clone,
         and .is-active drives a 0.4s opacity fade plus a 0.45s grayscale
         fade. So both cards would cross-fade against each other even though
         they are the same picture, and that reads as a blink on every wrap.
         is-jumping kills those transitions for the length of the swap, which
         is the whole reason the clone trick is invisible. */
      var jumpTimer = null;
      function jump(px) {
        root.classList.add('is-jumping');
        var prev = track.style.scrollBehavior;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = px;
        void track.offsetWidth;
        track.style.scrollBehavior = prev || '';

        /* Held past the scroll event the assignment queues, so the paint it
           triggers is covered too. */
        window.clearTimeout(jumpTimer);
        jumpTimer = window.setTimeout(function () {
          root.classList.remove('is-jumping');
        }, 90);
      }

      function indexFromScroll() {
        if (!stride) return 0;
        if (!looping) {
          /* The inner's trailing padding means the last card can never reach
             (n-1) * stride, so rounding alone reports the second to last card
             at the end of the run. Pin both ends explicitly. */
          var max = maxScroll();
          var x0 = track.scrollLeft;
          if (x0 <= 2) return 0;
          if (x0 >= max - 2) return slides.length - 1;
        }
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / stride)));
      }

      /* ---------------- action clips ----------------
         Still first, clip second, still again. The still is the resting
         state, so it is what renders on load and what remains if the clip
         never arrives.

         Only ever the ACTIVE card. The markup ships no src at all, so five
         riders across three clone sets is fifteen <video> elements that have
         downloaded nothing; the source is attached the moment a card becomes
         current and not before. The short delay means flicking through the
         whole run does not kick off five downloads on the way past. */
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var clipCap = (parseFloat(root.getAttribute('data-clip-seconds')) || 3) * 1000;
      var clipTimers = [];

      function stopClip(slide) {
        var v = slide.querySelector('[data-tcx-clip]');
        if (!v) return;
        slide.classList.remove('is-clip-playing');
        try { v.pause(); v.currentTime = 0; } catch (e) { /* not loaded yet */ }
      }

      function clearClipTimers() {
        for (var t = 0; t < clipTimers.length; t++) window.clearTimeout(clipTimers[t]);
        clipTimers = [];
      }

      function armClip(slide) {
        if (reduceMotion || !slide) return;
        var v = slide.querySelector('[data-tcx-clip]');
        if (!v) return;

        clipTimers.push(window.setTimeout(function () {
          if (!slide.classList.contains('is-active')) return;

          if (!v.getAttribute('src')) {
            v.setAttribute('src', v.getAttribute('data-clip-src'));
            v.muted = true;               // property, not just the attribute: iOS
            v.playsInline = true;         // checks the property before allowing autoplay
            v.load();
          }

          var done = function () {
            slide.classList.remove('is-clip-playing');
            try { v.pause(); v.currentTime = 0; } catch (e) { /* ignore */ }
          };
          v.addEventListener('ended', done, { once: true });
          clipTimers.push(window.setTimeout(done, clipCap));

          /* play() rejects on any browser that refuses the autoplay. Swallow
             it: the still is already showing and is the correct fallback. */
          var pr = v.play();
          if (pr && typeof pr.then === 'function') {
            pr.then(function () { slide.classList.add('is-clip-playing'); }, function () { done(); });
          } else {
            slide.classList.add('is-clip-playing');
          }
        }, 600));
      }

      function paint(i) {
        index = i;
        var lg = logicalOf(i);
        clearClipTimers();
        for (var q = 0; q < slides.length; q++) if (q !== i) stopClip(slides[q]);
        for (var s = 0; s < slides.length; s++) slides[s].classList.toggle('is-active', s === i);
        armClip(slides[i]);
        for (var t = 0; t < ticks.length; t++) ticks[t].classList.toggle('is-active', t === lg);
        if (counter) counter.textContent = pad2(lg + 1) + ' / ' + pad2(n);
        /* With looping there is always somewhere to go in both directions, so
           the hints never dim. */
        if (prevBtn) prevBtn.setAttribute('data-hidden', (!looping && i === 0) ? 'true' : 'false');
        if (nextBtn) nextBtn.setAttribute('data-hidden', (!looping && i === slides.length - 1) ? 'true' : 'false');
      }

      /* Direct assignment, NOT scrollTo({ behavior: 'smooth' }). Under
         scroll-snap-type: x mandatory the smooth-scroll animation and the snap
         engine fight, and iOS Safari settles on a neighbouring card. CSS
         scroll-behavior does the smoothing and is already switched off under
         prefers-reduced-motion.

         The target is derived from the cards themselves rather than from
         i * stride, so it stays exact even if a card is ever a different
         width. With scroll-padding-left matching the inner padding this IS
         the browser's own snap position, so nothing is corrected afterwards
         and the card does not visibly jump. */
      function goTo(i) {
        var next = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollLeft = Math.min(slides[next].offsetLeft - slides[0].offsetLeft, maxScroll());
      }

      /* Rewind into the middle copy. Only ever called once scrolling has
         stopped. */
      function normalize() {
        if (!looping || !stride) return;
        var w = setWidth();
        var x = track.scrollLeft;
        while (x < w - 1) x += w;
        while (x >= (2 * w) - 1) x -= w;
        if (Math.abs(x - track.scrollLeft) > 0.5) {
          jump(x);
          index = indexFromScroll();
          paint(index);
        }
      }

      var scrollRaf = null;
      var settleTimer = null;
      track.addEventListener('scroll', function () {
        if (!scrollRaf) {
          scrollRaf = window.requestAnimationFrame(function () {
            scrollRaf = null;
            var i = indexFromScroll();
            if (i !== index) paint(i);
          });
        }
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(normalize, 160);
      }, { passive: true });

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      });


      /* Never cache the stride across a breakpoint: the card width and the
         inset both change with it. Re-anchor on the logical card, not on the
         stale pixel offset. */
      var resizeRaf = null;
      function onResize() {
        if (resizeRaf) window.cancelAnimationFrame(resizeRaf);
        resizeRaf = window.requestAnimationFrame(function () {
          var lg = logicalOf(index);
          stride = measureStride();
          var target = looping ? setWidth() + (lg * stride) : lg * stride;
          jump(Math.min(target, maxScroll()));
          index = indexFromScroll();
          paint(index);
        });
      }
      window.addEventListener('resize', onResize);
      window.addEventListener('orientationchange', onResize);

      /* Team film. The embed is built on click and never before, so YouTube
         loads nothing for a visitor who does not press play. */
      var film = root.querySelector('[data-tcx-film]');
      var filmBtn = film && film.querySelector('[data-tcx-film-play]');
      if (film && filmBtn) {
        filmBtn.addEventListener('click', function () {
          var type = film.getAttribute('data-video-type');
          var id = film.getAttribute('data-video-id');
          var src = '';
          if (type === 'youtube') {
            src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) +
                  '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
          } else if (type === 'vimeo') {
            src = 'https://player.vimeo.com/video/' + encodeURIComponent(id) +
                  '?autoplay=1&title=0&byline=0&portrait=0';
          }
          if (!src) return;

          var frame = document.createElement('iframe');
          frame.src = src;
          frame.title = film.getAttribute('data-video-title') || 'Team video';
          frame.loading = 'eager';
          frame.allow = 'autoplay; encrypted-media; picture-in-picture';
          frame.allowFullscreen = true;
          film.replaceChildren(frame);
          frame.focus();
        });
      }

      /* ---------------- remembered size pill ----------------
         p7-size-prefs.js is loaded globally from theme.liquid:258 and owns
         the shopper's size. Read it, never write it: this row shows the size,
         the size grid is what sets it.

         Shoe sizes are single-select by that file's contract (normalizePrefs
         slices s to one), so there is at most one pill. It only appears when
         the shoe actually stocks that size and the variant is in stock, which
         is why the in-stock list is baked into data-sizes server-side rather
         than guessed here. */
      function paintSizePills() {
        var api = window.P7SizePrefs;
        var want = '';
        if (api && typeof api.read === 'function') {
          var prefs = api.read();
          want = (prefs && prefs.s && prefs.s[0]) || '';
        }
        var pills = root.querySelectorAll('[data-tcx-size]');
        for (var i = 0; i < pills.length; i++) {
          var pill = pills[i];
          var shoe = pill.closest ? pill.closest('.p7-tcx-card__shoe') : null;
          var listed = ((shoe && shoe.getAttribute('data-sizes')) || '')
            .split(',').filter(function (x) { return x !== ''; });

          var show = false;
          if (want && listed.length) {
            show = api && typeof api.matches === 'function'
              ? api.matches(listed, [want])
              : listed.indexOf(want) !== -1;
          }
          pill.textContent = show ? want : '';
          pill.hidden = !show;
        }
      }

      document.addEventListener('p7:size-prefs-change', paintSizePills);
      document.addEventListener('p7:size-prefs-memory-change', paintSizePills);
      paintSizePills();

      stride = measureStride();
      if (bar && n > 1) bar.hidden = false;
      if (looping) jump(setWidth());
      index = indexFromScroll();
      paint(index);
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-p7-tcx]'), init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector ? e.target.querySelector('[data-p7-tcx]') : null;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p7-team-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTeamHero(root) {
      if (!root || root.dataset.p7TeamHeroReady === 'true') return;
      root.dataset.p7TeamHeroReady = 'true';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-p7-team-hero-slide]'));
      var names = Array.prototype.slice.call(root.querySelectorAll('[data-p7-team-hero-name]'));
      var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-p7-team-hero-cta]'));
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-p7-team-hero-tab]'));
      var cycleMs = parseInt(root.dataset.cycleMs, 10) || 3000;
      var activeIndex = 0;
      var timer = null;
      var isVisible = true;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function normalizeIndex(index) {
        if (!slides.length) return 0;
        return (index + slides.length) % slides.length;
      }

      function setActive(index) {
        activeIndex = normalizeIndex(index);

        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        names.forEach(function (name, nameIndex) {
          var active = nameIndex === activeIndex;
          name.classList.toggle('is-active', active);
          name.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        ctas.forEach(function (cta, ctaIndex) {
          var active = ctaIndex === activeIndex;
          var disabled = cta.getAttribute('aria-disabled') === 'true';
          cta.classList.toggle('is-active', active);
          cta.setAttribute('aria-hidden', active ? 'false' : 'true');
          cta.tabIndex = active && !disabled ? 0 : -1;
        });

        tabs.forEach(function (tab, tabIndex) {
          var active = tabIndex === activeIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      function stopCycle() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function startCycle() {
        if (reduceMotion || slides.length < 2 || !isVisible) return;
        if (timer) window.clearInterval(timer);
        timer = window.setInterval(function () {
          setActive(activeIndex + 1);
        }, cycleMs);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          setActive(parseInt(tab.dataset.index, 10) || 0);
          startCycle();
        });
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopCycle();
        } else {
          startCycle();
        }
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            isVisible = entry.isIntersecting;
          });
          if (isVisible) {
            startCycle();
          } else {
            stopCycle();
          }
        }, { threshold: 0.25 });
        observer.observe(root);
      } else {
        startCycle();
      }

      setActive(0);
      startCycle();
    }

    function initAllTeamHeroes() {
      var roots = document.querySelectorAll('[data-p7-team-hero]');
      Array.prototype.forEach.call(roots, initTeamHero);
    }

    initAllTeamHeroes();
    document.addEventListener('shopify:section:load', initAllTeamHeroes);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p7-team"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.p7-team');
    if (!sections.length) return;

    function buildHeroVideoSrc(type, id) {
      var encodedId = encodeURIComponent(id);
      if (type === 'youtube') {
        return 'https://www.youtube.com/embed/' + encodedId + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
      }
      if (type === 'vimeo') {
        return 'https://player.vimeo.com/video/' + encodedId + '?autoplay=1&title=0&byline=0&portrait=0';
      }
      return '';
    }

    function playHeroVideo(section) {
      if (section.getAttribute('data-p7-team-video-playing') === 'true') return;

      var slot = section.querySelector('[data-p7-team-video-slot]');
      var type = section.getAttribute('data-p7-team-video-type');
      var id = section.getAttribute('data-p7-team-video-id');
      var title = section.getAttribute('data-p7-team-video-title') || 'Team video';
      var src = buildHeroVideoSrc(type, id);
      if (!slot || !src) return;

      var iframe = document.createElement('iframe');
      iframe.className = 'p7-team__video-frame';
      iframe.src = src;
      iframe.title = title;
      iframe.loading = 'eager';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;

      while (slot.firstChild) {
        slot.removeChild(slot.firstChild);
      }

      slot.appendChild(iframe);
      section.setAttribute('data-p7-team-video-playing', 'true');
      section.classList.add('is-video-playing');
    }

    sections.forEach(function (section) {
      var videoTriggers = Array.prototype.slice.call(section.querySelectorAll('[data-p7-team-video-trigger]'));
      var links = Array.prototype.slice.call(section.querySelectorAll('[data-p7-team-jump]'));
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-p7-team-card]'));

      videoTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          playHeroVideo(section);
        });
      });

      if (!cards.length) return;

      function setActive(id) {
        links.forEach(function (link) {
          var active = link.getAttribute('href') === '#' + id;
          link.classList.toggle('is-active', active);
          if (active) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
        cards.forEach(function (card) {
          card.classList.toggle('is-active', card.id === id);
        });
      }

      if (!('IntersectionObserver' in window)) {
        setActive(cards[0].id);
        return;
      }

      section.classList.add('p7-team--scroll-reveal');

      var visible = {};
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visible[entry.target.id] = entry.intersectionRatio;
          } else {
            delete visible[entry.target.id];
          }
        });

        var activeId = cards[0].id;
        var activeRatio = 0;
        Object.keys(visible).forEach(function (id) {
          if (visible[id] >= activeRatio) {
            activeRatio = visible[id];
            activeId = id;
          }
        });
        setActive(activeId);
      }, {
        rootMargin: '-35% 0px -45% 0px',
        threshold: [0, 0.2, 0.4, 0.6, 0.8]
      });

      cards.forEach(function (card) {
        observer.observe(card);
      });
      setActive(cards[0].id);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
